export enum ExternalLaunchType {
  APPOINTMENT_LAUNCH = 'appointment-launch',
  GENERIC_SMART_ON_FHIR = 'generic-smart-on-fhir',
  HEALTHDIRECT = 'healthdirect',
  MEDTECH = 'medtech',
  OPENAPI = 'openapi',
  SGIMED = 'sgimed',
}

export interface ExternalLaunchContextBase {
  sessionId: string | null;
  ehrProvider: string | null;
  onboardingSessionId: string | null;
  showPushButton: boolean;
}

/**
 * `/integration/appointment-launch`: the EHR opens Heidi with an encounter
 * number, the page resolves the schedule row and lands on its session.
 * `ehrProvider` is whichever connected integration answered the lookup.
 */
export interface AppointmentLaunchContext extends ExternalLaunchContextBase {
  launchType: ExternalLaunchType.APPOINTMENT_LAUNCH;
  showPushButton: true;
}

export interface GenericSmartOnFhirLaunchContext extends ExternalLaunchContextBase {
  launchType: ExternalLaunchType.GENERIC_SMART_ON_FHIR;
}

export interface HealthdirectLaunchContext extends ExternalLaunchContextBase {
  launchType: ExternalLaunchType.HEALTHDIRECT;
}

export interface MedtechLaunchContext extends ExternalLaunchContextBase {
  launchType: ExternalLaunchType.MEDTECH;
}

export interface SgimedLaunchContext extends ExternalLaunchContextBase {
  launchType: ExternalLaunchType.SGIMED;
}

export interface OpenApiLaunchContext extends ExternalLaunchContextBase {
  launchType: ExternalLaunchType.OPENAPI;
  sessionId: string;
  ehrProvider: string;
  onboardingSessionId: null;
  showPushButton: false;
}

export type ExternalLaunchContext =
  | AppointmentLaunchContext
  | GenericSmartOnFhirLaunchContext
  | HealthdirectLaunchContext
  | MedtechLaunchContext
  | OpenApiLaunchContext
  | SgimedLaunchContext;
